

























import { Vue, Component, Model, Prop } from "vue-property-decorator";
import {
  ProgramChain,
  getEndDateOfProgramChain,
} from "@/data/models/ProgramChain";
import { DryingDurationRating } from "@/data/models/DryingDurationRating";
import { firestore } from "firebase";
import { filterOutUndefined } from "@/utils/Utils";
import DatePickerCompoment from "@/components/common/DatePicker.vue";

@Component({
  components: {
    "date-picker": DatePickerCompoment,
  },
})
export default class RateDryingDurationComponent extends Vue {
  @Model("value")
  dryingDurationRating!: DryingDurationRating;

  @Prop()
  programChain!: ProgramChain;

  get dryingStartDate() {
    return this.programChain.startDate;
  }

  get dryingEndDate() {
    return getEndDateOfProgramChain(this.programChain);
  }

  get shouldHaveStoppedAt() {
    return this.dryingDurationRating.shouldHaveStoppedAt ?? null;
  }

  set shouldHaveStoppedAt(timestamp: firestore.Timestamp | null) {
    this.$emit(
      "value",
      filterOutUndefined({
        shouldHaveRunLonger: null,
        shouldHaveStoppedAt: timestamp,
      })
    );
  }

  get shouldHaveRunLonger() {
    return this.dryingDurationRating.shouldHaveRunLonger == true;
  }

  set shouldHaveRunLonger(value: boolean) {
    this.$emit(
      "value",
      filterOutUndefined({
        shouldHaveRunLonger: value,
        shouldHaveStoppedAt: null,
      })
    );
  }
}
